var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5016 4.37502H7.4983C6.52959 3.06654 7.8347 1.23525 9.45587 1.75823L10.229 2.00764C10.405 2.06442 10.5949 2.06442 10.7709 2.00764L11.5441 1.75823C13.1653 1.23525 14.4704 3.06654 13.5016 4.37502ZM7.58845 5.62502H13.4115C14.5109 6.23375 15.3698 7.25013 15.7631 8.50865L16.8048 11.842C17.8109 15.0616 15.4056 18.3334 12.0324 18.3334H8.9676C5.5944 18.3334 3.18906 15.0616 4.1952 11.842L5.23686 8.50865C5.63015 7.25013 6.48905 6.23375 7.58845 5.62502ZM13.3033 14.7132C13.6051 14.5456 13.7139 14.1652 13.5464 13.8634C13.3789 13.5616 12.9984 13.4527 12.6966 13.6202C11.7224 14.161 11.0545 14.3751 10.4501 14.3727C9.84872 14.3702 9.21719 14.153 8.31482 13.6268C8.01664 13.4529 7.63395 13.5537 7.46006 13.8518C7.28617 14.15 7.38692 14.5327 7.6851 14.7066C8.66138 15.2759 9.52062 15.6189 10.445 15.6227C11.3662 15.6264 12.2591 15.2927 13.3033 14.7132Z",
    fill: "#0E26AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/Money.a729dea7.svg";
export { ForwardRef as ReactComponent };